/* Pialu — Constructor de combos (req 4). Selección + descuento progresivo + carrito. */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    format = format || '${{amount}}';
    var value = (cents / 100);
    function withDelimiters(num, precision, thousands, decimal) {
      num = (num || 0).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + (thousands || ','));
      var cents = parts[1] ? (decimal || '.') + parts[1] : '';
      return dollars + cents;
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
      switch (name) {
        case 'amount': return withDelimiters(value, 2, ',', '.');
        case 'amount_no_decimals': return withDelimiters(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(value, 2, "'", '.');
        default: return withDelimiters(value, 2, ',', '.');
      }
    });
  }

  function initCombo(root) {
    if (root.dataset.comboInit === '1') return;
    root.dataset.comboInit = '1';

    var fmt = root.dataset.moneyFormat || '${{amount}}';
    var start = parseInt(root.dataset.tierStart, 10) || 2;
    var inc = parseInt(root.dataset.tierIncrement, 10) || 5;
    var maxD = parseInt(root.dataset.tierMax, 10) || 25;

    var base = null; // {id, price, title}
    var charms = {};  // id -> {qty, price, title}

    var els = {
      list: root.querySelector('[data-combo-list]'),
      empty: root.querySelector('[data-combo-cart-empty]'),
      pieces: root.querySelector('[data-combo-pieces]'),
      disc: root.querySelector('[data-combo-disc]'),
      discRow: root.querySelector('[data-combo-disc-row]'),
      total: root.querySelector('[data-combo-total]'),
      hint: root.querySelector('[data-combo-hint]'),
      add: root.querySelector('[data-combo-add]')
    };

    function pieces() {
      var n = base ? 1 : 0;
      Object.keys(charms).forEach(function (id) { n += charms[id].qty; });
      return n;
    }
    function discountPct(p) {
      if (p < start) return 0;
      return Math.min(maxD, (p - start + 1) * inc);
    }
    function subtotalCents() {
      var s = base ? base.price : 0;
      Object.keys(charms).forEach(function (id) { s += charms[id].price * charms[id].qty; });
      return s;
    }

    function render() {
      var p = pieces();
      var d = discountPct(p);
      var sub = subtotalCents();
      var total = Math.round(sub * (1 - d / 100));

      // lista
      var items = [];
      if (base) items.push({ title: base.title, qty: 1, price: base.price });
      Object.keys(charms).forEach(function (id) {
        items.push({ title: charms[id].title, qty: charms[id].qty, price: charms[id].price });
      });
      if (els.list) {
        els.list.innerHTML = items.map(function (it) {
          return '<li><span>' + (it.qty > 1 ? it.qty + '× ' : '') + it.title + '</span><span>' + formatMoney(it.price * it.qty, fmt) + '</span></li>';
        }).join('');
      }
      if (els.empty) els.empty.hidden = items.length > 0;

      if (els.pieces) els.pieces.textContent = p;
      if (els.disc) els.disc.textContent = d;
      if (els.discRow) els.discRow.hidden = d <= 0;
      if (els.total) els.total.textContent = items.length ? formatMoney(total, fmt) : '—';

      if (els.hint) {
        if (p < start) {
          var need = start - p;
          els.hint.textContent = 'Agrega ' + need + (need === 1 ? ' pieza más' : ' piezas más') + ' y obtén ' + inc + '% de descuento.';
        } else if (d < maxD) {
          els.hint.textContent = 'Agrega 1 pieza más y sube a ' + Math.min(maxD, d + inc) + '% de descuento.';
        } else {
          els.hint.textContent = '¡Tienes el máximo descuento (' + maxD + '%)!';
        }
      }

      if (els.add) els.add.disabled = !base;
    }

    // Base (radio)
    root.querySelectorAll('[data-combo-base]').forEach(function (card) {
      var input = card.querySelector('.combo-card__radio');
      if (!input) return;
      input.addEventListener('change', function () {
        root.querySelectorAll('[data-combo-base]').forEach(function (c) { c.classList.remove('is-selected'); });
        card.classList.add('is-selected');
        base = { id: card.dataset.comboBase, price: parseInt(card.dataset.price, 10) || 0, title: card.dataset.title };
        render();
      });
    });

    // Charms (+/-)
    root.querySelectorAll('[data-combo-charm]').forEach(function (card) {
      var id = card.dataset.comboCharm;
      var valEl = card.querySelector('[data-combo-qtyval]');
      var plus = card.querySelector('[data-combo-plus]');
      var minus = card.querySelector('[data-combo-minus]');
      function setQty(q) {
        q = Math.max(0, q);
        if (q === 0) { delete charms[id]; }
        else { charms[id] = { qty: q, price: parseInt(card.dataset.price, 10) || 0, title: card.dataset.title }; }
        if (valEl) valEl.textContent = q;
        card.classList.toggle('is-selected', q > 0);
        render();
      }
      if (plus) plus.addEventListener('click', function () { setQty((charms[id] ? charms[id].qty : 0) + 1); });
      if (minus) minus.addEventListener('click', function () { setQty((charms[id] ? charms[id].qty : 0) - 1); });
    });

    // Agregar al carrito
    if (els.add) {
      els.add.addEventListener('click', function () {
        if (!base) return;
        var p = pieces();
        var d = discountPct(p);
        var comboId = 'combo-' + (new Date()).getTime() + '-' + Math.floor((window.crypto ? crypto.getRandomValues(new Uint32Array(1))[0] : 0));
        var props = { _combo: comboId, _combo_pieces: String(p), _combo_descuento: d + '%' };
        var items = [{ id: base.id, quantity: 1, properties: props }];
        Object.keys(charms).forEach(function (id) {
          items.push({ id: id, quantity: charms[id].qty, properties: props });
        });
        els.add.disabled = true;
        var original = els.add.textContent;
        els.add.textContent = 'Agregando…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) { return r.json(); }).then(function () {
          ['cart:refresh', 'cart:updated'].forEach(function (ev) {
            document.dispatchEvent(new CustomEvent(ev, { bubbles: true }));
          });
          window.location.href = '/cart';
        }).catch(function () {
          els.add.disabled = false; els.add.textContent = original;
        });
      });
    }

    render();
  }

  function boot() {
    document.querySelectorAll('[data-combo]').forEach(initCombo);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', function (e) {
    (e.target || document).querySelectorAll('[data-combo]').forEach(initCombo);
  });
})();
